import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Ionic from '@ionic/vue';
import BootstrapVue from 'bootstrap-vue'
import {DeviceEventBus} from './DeviceEventBus'
import Notifications from 'vue-notification'

// Capacitor
import { Plugins, StatusBarStyle,PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed  } from '@capacitor/core'
const { SplashScreen, StatusBar, Network,PushNotifications } = Plugins



Vue.config.productionTip = false
// ionic 
Vue.use(Ionic);
/* Core CSS required for Ionic components to work properly */
import "@ionic/core/css/core.css";
/* Basic CSS for apps built with Ionic */
import "@ionic/core/css/normalize.css";
import "@ionic/core/css/structure.css";
import "@ionic/core/css/typography.css";
/* Optional CSS utils that can be commented out */
import "@ionic/core/css/padding.css";
import "@ionic/core/css/float-elements.css";
import "@ionic/core/css/text-alignment.css";
import "@ionic/core/css/text-transformation.css";
import "@ionic/core/css/flex-utils.css";
import "@ionic/core/css/display.css";

//Bootstrap 4
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// vue notification
Vue.use(Notifications)

//Helpers 
import helpers from './helpers'

Vue.prototype.$helpers = helpers

let backGroundedTimer 


let application = new Vue({
  data(){
    return {
      conCounter:0,
      isSplashScreenTimer:null,
      loadingController:null,
      connectionInit:null,
      handleAppStateAfter: 5000,
      appState:null

    }
  },
  beforeCreate (){
    initApplication()
    // SplashScreen.fadeOutDuration = 2000
  },
  created(){},
  router,
  store,
   
  async mounted(){
   
    /*Timer for initiat connection to server once Network status is true*/
    this.connectionInit = setInterval (this.initConnection,1000)   
    /* handle splash screen */
    this.isSplashScreenTimer= setInterval (this.handleSplashScreen,1000)

    /**Only showing Modal Element to user which App trying to  establish connection*/
    DeviceEventBus.$on("NetWorkStatus",this.handleNetworkStatus)

   
  },
  methods:{
    initConnection(){
        
        if(DeviceEventBus.getNetWorkStatus){
          
         
          store.dispatch('connection/connect',{} )
            // store.dispatch('connection/connect',Vue.prototype.$helpers.deviceInfo )
          clearInterval(this.connectionInit)

          /* Handle app backgrounding & forgrounding*/
          DeviceEventBus.$on('appState',this.handleAppState) 
   
          DeviceEventBus.$on('connectionStatus',this.activeDisconnected)
  
        }
        
    },
    async activeDisconnected (status){
     
      if(!status.connected){
        if(!this.loadingController){
          this.loadingController = await this.$ionic.loadingController.create(
            { message: 'Connecting 3',spinner:"crescent",animated:true,translucent:true})
            this.loadingController.present()
        }
      }else{
        if(this.loadingController){ 
          this.loadingController.dismiss() 
          this.loadingController=null
        }
      }
    
    },
    async handleNetworkStatus(status){
      
      console.log("***************************************************\n") 
      console.log("main:DeviceEventBus:on:NetWorkStatus", JSON.stringify(status) )
      console.log("***************************************************\n") 
    
      
      if(!status.connected){
        if(!this.loadingController){
          this.loadingController = await this.$ionic.loadingController.create(
            { message: 'Connecting 2',spinner:"crescent",animated:true,translucent:true})
            this.loadingController.present()
        }
      }else{
        if(this.loadingController){ 
          this.loadingController.dismiss() 
          this.loadingController=null
        }
      }

    },
    async handleSplashScreen(){
      
      if(store.state.connection.connected){
       
        SplashScreen.hide().catch(this.$helpers.err)
        clearInterval(this.isSplashScreenTimer)
       
      }
     
    },
    handleAppState(state){
      
       
      // setTimeout(()=>{
        if(!this.$helpers.isWeb()){
          
          if(state.isActive){
            
            if(!store.state.connection.connected){  
              
              store.dispatch('connection/connect',{} )
            }
          
          }else{
            
            if(store.state.connection.connected){
              console.log("***************************************************\n") 
              console.log("main:handleAppState:Calling =>connection/disconnect")
              console.log("***************************************************\n") 
              store.dispatch('connection/disconnect',{} )
            }
          }
        }else{
          // console.log("Its web do nothing  ",state.isActive)
        }

      // } ,this.handleAppStateAfter)
         
  
    }
  },
  render: h => h(App)
})
application.$mount('#app')

async function initApplication() {
  // Platform checks
  Vue.prototype.$isWeb = helpers.isWeb()
  Vue.prototype.$isIOS = helpers.isIOS()
  /*
    Initialize DeviceEvent Bus which handles 
    network status  & orientation changes
  */ 
  DeviceEventBus.init()
  
}
